export const discoverRowCtaButtonClassName =
  "group inline-flex h-8 shrink-0 items-center gap-0.5 rounded-full border border-border bg-background px-3 text-xs font-medium text-foreground shadow-sm transition-colors hover:bg-muted/60 dark:border-white/12 dark:hover:bg-white/10";

export const discoverRowCtaChevronClassName =
  "h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5";
